import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import HomeworkTable from "../../components/reportTables/HomeworkTable";
import { StyledInput } from "../../components/login/StyledInput";
import { useAuthContext } from "../../context/authContext";
import {
  setDocumentTitle,
  useSiteNameContext,
} from "../../context/siteNameContext";
import { Button } from "../../shared/button";
import { UserService } from "../../APIService/UserService";
import { TUserInfo, THomeworkType } from "../../types";
import AdminService from "../../APIService/AdminService";
import { isAdmin, isTeacher } from "../../helpers/role";

export function HomeworkPage() {
  const { siteNameList } = useSiteNameContext();
  setDocumentTitle(siteNameList, "report25");

  const { authInfo } = useAuthContext();
  const params = useParams();
  const id = params.id ? Number(params.id) : authInfo.id;
  const [days, setDays] = useState<number>(30);
  const [daysToShow, setDaysToShow] = useState<number>(180);
  const [error, setError] = useState<boolean>(false);
  const [userInfo, setUserInfo] = useState<TUserInfo>({} as TUserInfo);
  const [homeworkData, setHomeworkData] = useState<THomeworkType[]>([]);

  const handleChange = (event: any) => {
    const { value } = event.target;
    setDaysToShow(value);
    setError(value > 180 || value < 0);
  };

  const handleClick = () => {
    setDays(daysToShow);
  };

  useEffect(() => {
    UserService.getUserInfo(id).then((user) => {
      setUserInfo(user);
    });
  }, []);

  useEffect(() => {
    setDays(daysToShow);
    AdminService.getAnswer25Info(id, days).then((result) => {
      setHomeworkData(result.data);
    });
  }, [days]);

  return (
    <div className="WideWrapper">
      <h2>
        Отчет 25. Домашние задания ученика {id}{" "}
        {isAdmin(authInfo.role) || isTeacher(authInfo.role)
          ? " (" + userInfo?.sysName + ")"
          : ""}{" "}
        за несколько дней
      </h2>

      <Grid item xs={12} sm={4} md={2}>
        <StyledInput
          size="small"
          label={"Дни"}
          value={daysToShow}
          onChange={handleChange}
        />
        {error ? <p>{"Введите число, меньшее 180 и большее 0"}</p> : <p></p>}

        <Grid item xs={12} sm={4} md={3}>
          <Button disabled={error} onClick={handleClick}>
            Обновить отчет
          </Button>
        </Grid>
      </Grid>
      <p />
      <div>
        {homeworkData?.length ? (
          <HomeworkTable tableData={homeworkData} />
        ) : (
          <p>
            Ой, кажется, нет статистики за указанный период! Попробуйте изменить
            период!{" "}
          </p>
        )}
      </div>
    </div>
  );
}
